import { createStore ,applyMiddleware} from 'redux';
import {MainReducer} from './reducers';
import thunk from 'redux-thunk';
import { persistStore, persistReducer } from 'redux-persist';
import AsyncStorage from '@react-native-community/async-storage';
import { composeWithDevTools } from 'redux-devtools-extension';

const authPersistConfig = {
    key: 'auth',
    storage:AsyncStorage,
}
  

const persistedReducer = persistReducer(authPersistConfig, MainReducer);
let store = createStore(persistedReducer,composeWithDevTools(applyMiddleware(thunk)));
let persistor = persistStore(store);

global.dispatch = store.dispatch;

export { store, persistor };